import {
  type RequestParams,
  type UdfResponse,
  type UdfErrorResponse,
  logMessage,
} from '@/shared/lib/datafeed/helpers';
import { type IRequester } from '@/shared/lib/datafeed/irequester';

export class Requester implements IRequester {
  private _headers: HeadersInit | undefined;

  public constructor(headers?: HeadersInit) {
    if (headers) {
      this._headers = headers;
    }
  }

  public sendRequest<T extends UdfResponse>(
    datafeedUrl: string,
    urlPath: string,
    params?: RequestParams,
  ): Promise<T | UdfErrorResponse>;
  public sendRequest<T>(datafeedUrl: string, urlPath: string, params?: RequestParams): Promise<T>;
  public sendRequest<T>(datafeedUrl: string, urlPath: string, params?: RequestParams): Promise<T> {
    let path = urlPath;
    if (params !== undefined) {
      const paramKeys = Object.keys(params);
      if (paramKeys.length !== 0) {
        path += '?';
      }

      path += paramKeys
        .map(
          (key: string) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(params[key].toString())}`,
        )
        .join('&');
    }

    logMessage(`New request: ${path}`);

    // Send user cookies if the URL is on the same origin as the calling script.
    const options: RequestInit = { credentials: 'same-origin' };

    if (this._headers !== undefined) {
      options.headers = this._headers;
    }

    return fetch(`${datafeedUrl}/${path}`, options)
      .then((response: Response) => response.text())
      .then((responseTest: string) => JSON.parse(responseTest));
  }
}
